import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '',
      redirect: '/district',
      name: 'root',
    },
    {
      path: '/status',
      component: () => import(/* webpackChunkName: "chunk-status" */ '@/components/pages/Status.vue'),
      props: true,
    },
    {
      path: '/:abbreviation',
      component: () => import(/* webpackChunkName: "chunk-home" */ '@/components/pages/Home.vue'),
      props: true,
    },
    {
      path: '/:abbreviation/annual-calendar/:year?',
      name: 'DistrictAnnualCalendar',
      component: () =>
        import('@/components/pages/AnnualCalendar.vue'),
      props: true,
    },
    {
      path: '/:abbreviation/high-school-annual-calendar',
      name: 'HighSchoolAnnualCalendar',
      component: () =>
        import('@/components/pages/AnnualCalendar.vue'),
      props: true,
    },
  ]
})
